/**
 * Language versions of the site that search engines can index.
 *
 * English lives at the root (/services). German, French and Spanish — the
 * European markets we target — also get their own URLs (/de/services,
 * /fr/services, /es/services), prerendered in that language and tied
 * together with hreflang, so Google shows each country its own language.
 *
 * Only pages whose content is fully translated belong in LOCALIZED_PATHS;
 * a "German" URL full of English text would do more harm than good. Other
 * languages (Georgian, Russian, Turkish) still work everywhere through the
 * language switcher, just without their own URLs.
 *
 * Adding a localized page: add its path here and a translated title and
 * description to the de/fr/es locale files as "seoT.<path>" / "seoD.<path>".
 * The sitemap entries are generated by scripts/generate-sitemap-locales.js.
 */
export const LOCALIZED_LANGS = ['de', 'fr', 'es']

export const LOCALIZED_PATHS = [
  '/',
  '/services',
  '/services/ai-development',
  '/services/generative-ai',
  '/services/rag',
  '/services/rag-proof-of-concept',
  '/services/ai-agents',
  '/services/computer-vision',
  '/services/nlp-chatbots',
  '/services/data-engineering',
  '/services/mlops',
  '/services/web-development',
  '/services/mobile-development',
  '/services/seo',
  '/services/ui-ux-design',
  '/services/web-design',
  '/services/nearshore-ai-development-europe',
  '/services/ai-consulting',
  '/process',
  '/about-us',
  '/contact-us',
]

const LOCALIZED = new Set(LOCALIZED_PATHS)

// "/de/services" → { lang: 'de', base: '/services' }; "/services" → { lang: null, base: '/services' }
export const splitLocale = (pathname) => {
  const match = pathname.match(/^\/(de|fr|es)(\/.*)?$/)
  if (!match) return { lang: null, base: pathname }
  return { lang: match[1], base: match[2] || '/' }
}

export const isLocalized = (base) => LOCALIZED.has(base)

// The URL of `base` in `lang` ('en' or any other language → the root URL).
export const localizedPath = (base, lang) => {
  if (!LOCALIZED_LANGS.includes(lang) || !isLocalized(base)) return base
  return base === '/' ? `/${lang}` : `/${lang}${base}`
}

// hreflang values: search engines expect ISO codes.
export const HREFLANG = { en: 'en', de: 'de', fr: 'fr', es: 'es' }
export const OG_LOCALE = { en: 'en_US', de: 'de_DE', fr: 'fr_FR', es: 'es_ES', ge: 'ka_GE', ru: 'ru_RU', tr: 'tr_TR' }
